import { ref, computed, onBeforeMount, onMounted, onBeforeUnmount, openBlock, createElementBlock, normalizeClass, createElementVNode, normalizeStyle, renderSlot, toDisplayString, Fragment, createTextVNode, createCommentVNode, createVNode, withCtx, pushScopeId, popScopeId } from "vue";
import { useScrollLocker } from "../../uikit.utils/useScrollLocker.es.js";
import { useModalStore } from "../../uikit.stores/modal.es.js";
import { useScreenSizeStore } from "../../uikit.stores/screenSize.es.js";
import CloseIcon from "../../uikit.icons/CloseIcon.vue.es.js";
import { MODAL_PLACEMENT } from "./modal.es.js";
import UikitButton from "../Button.vue.es.js";
/* empty css              */
import _export_sfc from "../../uikit._virtual/_plugin-vue_export-helper.es.js";
const _withScopeId = (n) => (pushScopeId("data-v-b89da47b"), n = n(), popScopeId(), n);
const _hoisted_1 = ["id"];
const _hoisted_2 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", { class: "modal-mask" }, null, -1));
const _hoisted_3 = { class: "modal-wrapper-body" };
const _hoisted_4 = { class: "modal-header" };
const _hoisted_5 = { class: "modal-header-title" };
const _hoisted_6 = { class: "modal-title" };
const _hoisted_7 = {
  key: 0,
  class: "sub-title"
};
const _hoisted_8 = { class: "modal-header-extra" };
const _hoisted_9 = {
  key: 0,
  class: "separator"
};
const _hoisted_12 = { class: "modal-footer" };
const _sfc_main = {
  __name: "Modal",
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String
    },
    subTitle: {
      type: String,
      default: ""
    },
    validateText: {
      type: String,
      default: "Valider"
    },
    cancelText: {
      type: String,
      default: "Annuler"
    },
    onConfirmed: {
      type: Function,
      default: () => {
      }
    },
    onCanceled: {
      type: Function,
      default: () => {
      }
    }
  },
  emits: ["onClose"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const screenSizeStore = useScreenSizeStore();
    const modalStore = useModalStore();
    const uniqueId = Math.random().toString(36).substr(2, 9);
    const innerModal = ref(null);
    const innerModalHeight = ref(0);
    const isMobile = computed(() => screenSizeStore.isMaxTabletPortraitWidth);
    const placement = computed(() => isMobile.value ? MODAL_PLACEMENT.BOTTOM : MODAL_PLACEMENT.CENTER);
    const currentOffset = computed(() => modalStore.offset(props.id, placement.value));
    const isVisible = computed(() => modalStore.isVisible(props.id));
    const isActiveModal = computed(() => modalStore.isActive(props.id));
    const deviceHeight = ref(window.innerHeight);
    const ro = new ResizeObserver(() => {
      var _a;
      innerModalHeight.value = (_a = innerModal.value) == null ? void 0 : _a.clientHeight;
      deviceHeight.value = window.innerHeight;
    });
    modalStore.referenceInstance(props.id, {
      height: computed(() => innerModalHeight.value)
    });
    const modalClasses = computed(() => {
      const placementClass = `modal-${placement.value}`;
      return {
        [placementClass]: true,
        "modal-open": isVisible.value,
        "modal-bottom-sheet": isMobile.value
      };
    });
    const modalStyle = computed(() => {
      let offset = currentOffset.value;
      let translate = void 0;
      if (isMobile.value) {
        let height = "auto";
        let maxHeight = `calc(100% - ${offset}px)`;
        if (!isActiveModal.value) {
          height = `${offset}px`;
          maxHeight = void 0;
        } else if (deviceHeight.value - offset <= innerModalHeight.value) {
          height = `calc(100% - ${offset}px)`;
        }
        return {
          height,
          maxHeight,
          transform: translate
        };
      } else {
        if (offset) {
          translate = `translateX(${offset}px)`;
        }
        return {
          transform: translate
        };
      }
    });
    const close = () => {
      emit("onClose");
      modalStore.remove(props.id);
    };
    const handleClose = () => {
      close();
      props.onCanceled();
    };
    const handleValidate = () => {
      close();
      props.onConfirmed();
    };
    const { lock, unlock } = useScrollLocker(uniqueId);
    onBeforeMount(() => {
      lock();
    });
    onMounted(() => {
      ro.observe(innerModal.value);
    });
    onBeforeUnmount(() => {
      ro.unobserve(innerModal.value);
      unlock();
    });
    return (_ctx, _cache) => {
      return isVisible.value ? (openBlock(), createElementBlock("div", {
        key: 0,
        id: __props.id,
        ref: "modal",
        class: normalizeClass(["modal", modalClasses.value])
      }, [
        _hoisted_2,
        createElementVNode("div", {
          class: "modal-content-wrapper",
          style: normalizeStyle(modalStyle.value)
        }, [
          createElementVNode("div", {
            ref_key: "innerModal",
            ref: innerModal,
            class: "modal-content"
          }, [
            createElementVNode("div", _hoisted_3, [
              createElementVNode("div", _hoisted_4, [
                createElementVNode("div", _hoisted_5, [
                  renderSlot(_ctx.$slots, "header", {}, () => [
                    createElementVNode("div", _hoisted_6, toDisplayString(__props.title), 1),
                    _ctx.$slots.headerSubTitle || __props.subTitle !== "" ? (openBlock(), createElementBlock("div", _hoisted_7, [
                      _ctx.$slots.headerSubTitle ? renderSlot(_ctx.$slots, "headerSubTitle", { key: 0 }, void 0, true) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                        createTextVNode(toDisplayString(__props.subTitle), 1)
                      ], 64))
                    ])) : createCommentVNode("", true)
                  ], true)
                ]),
                createElementVNode("div", _hoisted_8, [
                  createVNode(CloseIcon, {
                    class: "modal-close",
                    onClick: handleClose
                  })
                ])
              ]),
              !isMobile.value ? (openBlock(), createElementBlock("div", _hoisted_9)) : createCommentVNode("", true),
              createCommentVNode("", true),
              createCommentVNode("", true),
              createElementVNode("div", _hoisted_12, [
                createVNode(UikitButton, {
                  class: normalizeClass({ "u-w-half": !isMobile.value }),
                  type: "secondary",
                  onClick: handleClose
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(__props.cancelText), 1)
                  ]),
                  _: 1
                }, 8, ["class"]),
                createVNode(UikitButton, {
                  class: normalizeClass({ "u-w-half": !isMobile.value }),
                  type: "primary",
                  onClick: handleValidate
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(__props.validateText), 1)
                  ]),
                  _: 1
                }, 8, ["class"])
              ])
            ])
          ], 512)
        ], 4)
      ], 10, _hoisted_1)) : createCommentVNode("", true);
    };
  }
};
const Modal = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-b89da47b"]]);
export {
  Modal as default
};
//# sourceMappingURL=Modal.vue.es.js.map
